import store from '../index'
import { userTypes } from '.'
import { storeUserInfo } from '../../helper/helper'

export const setUser = user => {
  storeUserInfo(user)
  store.dispatch({ type: userTypes.set, value: user })
}
